import { CREATE_NEW_SHOP_EMPLOYEE } from "../constants/endpoints";
import axiosClient from "./axios";

interface shopEmployeeData {
  shopId: string | null;
  name: string;
  phoneNumber?: string;
  email?: string;
  role: string;
  config?: { allowedCategories?: string[] };
  loginType?: "Email" | "Google";
  password?: string;
}

class createNewStoreEmployeeService {
  static async createNewStoreEmployee(data: shopEmployeeData) {
    const response = await axiosClient.post(CREATE_NEW_SHOP_EMPLOYEE, data);
    return response;
  }
}

export default createNewStoreEmployeeService;
